import KioskProductionList from './KioskProductionList'

export default KioskProductionList
